 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		47: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		47: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"styles","3":"component---src-pages-404-jsx","4":"component---src-pages-about-jsx","5":"component---src-pages-background-catalog-jsx","6":"component---src-pages-campaigns-index-jsx","7":"component---src-pages-campaigns-oota-index-jsx","8":"component---src-pages-campaigns-toa-generator-random-encounter-jsx","9":"component---src-pages-campaigns-toa-generator-treasures-jsx","10":"component---src-pages-campaigns-toa-index-jsx","11":"component---src-pages-creature-catalog-jsx","12":"component---src-pages-downtime-buy-magic-items-jsx","13":"component---src-pages-feat-catalog-jsx","14":"component---src-pages-gear-catalog-jsx","15":"component---src-pages-generator-characters-jsx","16":"component---src-pages-generator-loot-jsx","17":"component---src-pages-generator-madness-jsx","18":"component---src-pages-generator-names-jsx","19":"component---src-pages-generator-sentient-items-jsx","20":"component---src-pages-generator-spellbook-jsx","21":"component---src-pages-generator-wild-magic-jsx","22":"component---src-pages-god-catalog-jsx","23":"component---src-pages-index-jsx","24":"component---src-pages-infusion-catalog-jsx","25":"component---src-pages-invocation-catalog-jsx","26":"component---src-pages-language-catalog-jsx","27":"component---src-pages-magic-item-catalog-jsx","28":"component---src-pages-pc-class-catalog-jsx","29":"component---src-pages-race-catalog-jsx","30":"component---src-pages-roll-jsx","31":"component---src-pages-spell-catalog-jsx","32":"component---src-pages-vehicle-catalog-jsx","33":"component---src-templates-background-page-template-jsx","34":"component---src-templates-creature-page-template-jsx","35":"component---src-templates-feat-page-template-jsx","36":"component---src-templates-gear-page-template-jsx","37":"component---src-templates-god-page-template-jsx","38":"component---src-templates-infusion-page-template-jsx","39":"component---src-templates-invocation-page-template-jsx","40":"component---src-templates-language-page-template-jsx","41":"component---src-templates-magic-item-page-template-jsx","42":"component---src-templates-pc-class-page-template-jsx","43":"component---src-templates-pc-sub-class-page-template-jsx","44":"component---src-templates-race-page-template-jsx","45":"component---src-templates-spell-page-template-jsx","46":"component---src-templates-vehicle-page-template-jsx"}[chunkId]||chunkId) + "-" + {"1":"71acdf4c1892ca24c1ac","3":"da4848c0efaa02fdb475","4":"b41ca2babc932ea513d9","5":"c75a8bb3f0854757f5c4","6":"df2df464d62f42f4f71c","7":"b6516ceba9cb4704e665","8":"2a8612f3da1bcace5118","9":"1f911238428904e02da5","10":"5ee6fd4a529527d2dd7e","11":"5505bd22272598daaa41","12":"5af111364b4033ac0147","13":"ebb12e756c953cbc3291","14":"0d2223694f5d1137a8df","15":"2a8196e59166115e055f","16":"78c78ecc52c8e6ad9c59","17":"febbeb7ab5b737ac8f20","18":"f7ecaad5bda283389683","19":"2caf11964d1ff3029cc7","20":"44637f35e8d5e10acb43","21":"13b19f855f6d4e11ed18","22":"86620f7dc17d7c3305ad","23":"438efc751fde8d1240b7","24":"36f3a3f36f5667a71cdf","25":"afa8f8f24bfcfd5afc02","26":"388dd0e792100f1f59ae","27":"1bffa114fffab8d35b19","28":"1b413c341b3a3fb020ef","29":"274f7acde872242f91fd","30":"17aef5589faee6c8ac86","31":"3ad2ccbb3dc3f129cb80","32":"58fbb0e9493bc32cbb9e","33":"6ab3682766bf8c2b089d","34":"8fb8ca814ddb0ec535ab","35":"d567e2af2e0a62d3f100","36":"3a8345e55304a658c63f","37":"4f29f6e961fffc840ba8","38":"c8292fb65c160c0611a0","39":"0f66ae7713f5b82977fc","40":"4a18c66861f319d07202","41":"7e3fb00a531f69448c3c","42":"84f661ff95a4a361f291","43":"93e9a535cb42527aa2b4","44":"2514f3ebb0ee7431e6ba","45":"f554c7fa579f4cc3e8ae","46":"6af40eb9714584cd2316"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"styles","3":"component---src-pages-404-jsx","4":"component---src-pages-about-jsx","5":"component---src-pages-background-catalog-jsx","6":"component---src-pages-campaigns-index-jsx","7":"component---src-pages-campaigns-oota-index-jsx","8":"component---src-pages-campaigns-toa-generator-random-encounter-jsx","9":"component---src-pages-campaigns-toa-generator-treasures-jsx","10":"component---src-pages-campaigns-toa-index-jsx","11":"component---src-pages-creature-catalog-jsx","12":"component---src-pages-downtime-buy-magic-items-jsx","13":"component---src-pages-feat-catalog-jsx","14":"component---src-pages-gear-catalog-jsx","15":"component---src-pages-generator-characters-jsx","16":"component---src-pages-generator-loot-jsx","17":"component---src-pages-generator-madness-jsx","18":"component---src-pages-generator-names-jsx","19":"component---src-pages-generator-sentient-items-jsx","20":"component---src-pages-generator-spellbook-jsx","21":"component---src-pages-generator-wild-magic-jsx","22":"component---src-pages-god-catalog-jsx","23":"component---src-pages-index-jsx","24":"component---src-pages-infusion-catalog-jsx","25":"component---src-pages-invocation-catalog-jsx","26":"component---src-pages-language-catalog-jsx","27":"component---src-pages-magic-item-catalog-jsx","28":"component---src-pages-pc-class-catalog-jsx","29":"component---src-pages-race-catalog-jsx","30":"component---src-pages-roll-jsx","31":"component---src-pages-spell-catalog-jsx","32":"component---src-pages-vehicle-catalog-jsx","33":"component---src-templates-background-page-template-jsx","34":"component---src-templates-creature-page-template-jsx","35":"component---src-templates-feat-page-template-jsx","36":"component---src-templates-gear-page-template-jsx","37":"component---src-templates-god-page-template-jsx","38":"component---src-templates-infusion-page-template-jsx","39":"component---src-templates-invocation-page-template-jsx","40":"component---src-templates-language-page-template-jsx","41":"component---src-templates-magic-item-page-template-jsx","42":"component---src-templates-pc-class-page-template-jsx","43":"component---src-templates-pc-sub-class-page-template-jsx","44":"component---src-templates-race-page-template-jsx","45":"component---src-templates-spell-page-template-jsx","46":"component---src-templates-vehicle-page-template-jsx"}[chunkId]||chunkId) + "." + {"1":"95bf990affc5936fd3a6","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
